var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModuleSoftwares(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-module-softwares",
    transform: "translate(-31.637 0.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5839",
    "data-name": "Rectangle 5839",
    width: 92,
    height: 92,
    transform: "translate(31.637 -0.363)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8854",
    "data-name": "Group 8854",
    transform: "translate(48.299 16.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8853",
    "data-name": "Group 8853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8851",
    "data-name": "Group 8851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41075",
    "data-name": "Path 41075",
    d: "M57.828,18.838l2.266,7.018a15.775,15.775,0,0,1-4.4,1.974v7.254a15.791,15.791,0,0,1,4.4,1.979l-2.266,7.016a15.791,15.791,0,0,1-4.714-1.005L48.882,48.94a15.928,15.928,0,0,1,2.407,4.2l-5.93,4.337a15.948,15.948,0,0,1-3.225-3.6l-6.85,2.241a16.074,16.074,0,0,1-.505,4.825H27.449a16.077,16.077,0,0,1-.508-4.825l-6.848-2.241a15.959,15.959,0,0,1-3.227,3.6l-5.93-4.337a16.063,16.063,0,0,1,2.407-4.2l-4.23-5.867A15.806,15.806,0,0,1,4.4,44.079L2.131,37.063a15.774,15.774,0,0,1,4.4-1.979V27.83a15.758,15.758,0,0,1-4.4-1.974L4.4,18.838a15.882,15.882,0,0,1,4.716,1.005l4.23-5.867a16.063,16.063,0,0,1-2.407-4.2l5.93-4.337a16.011,16.011,0,0,1,3.227,3.6L26.942,6.8a16.077,16.077,0,0,1,.508-4.828h7.329A16.074,16.074,0,0,1,35.283,6.8l6.85,2.239a16,16,0,0,1,3.225-3.6l5.93,4.337a15.928,15.928,0,0,1-2.407,4.2l4.233,5.867A15.866,15.866,0,0,1,57.828,18.838Zm-7.907,12.62A18.808,18.808,0,1,0,31.114,50.4,18.873,18.873,0,0,0,49.922,31.458Z",
    transform: "translate(-2.131 -1.973)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8852",
    "data-name": "Group 8852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41076",
    "data-name": "Path 41076",
    d: "M16.635,26.286,9.36,19.014l7.275-7.269",
    transform: "translate(5.327 10.541)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41077",
    "data-name": "Path 41077",
    d: "M16.376,26.286l7.275-7.272-7.275-7.269",
    transform: "translate(19.625 10.541)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    x1: 6.574,
    y2: 20.787,
    transform: "translate(25.695 19.093)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41078",
    "data-name": "Path 41078",
    d: "M26.942,6.8a16.077,16.077,0,0,1,.508-4.828h7.329A16.074,16.074,0,0,1,35.283,6.8l6.85,2.239a16,16,0,0,1,3.225-3.6l5.93,4.337a15.928,15.928,0,0,1-2.407,4.2l4.233,5.867a15.866,15.866,0,0,1,4.714-1.005l2.266,7.018a15.775,15.775,0,0,1-4.4,1.974v7.254a15.791,15.791,0,0,1,4.4,1.979l-2.266,7.016a15.791,15.791,0,0,1-4.714-1.005L48.882,48.94a15.928,15.928,0,0,1,2.407,4.2l-5.93,4.337a15.948,15.948,0,0,1-3.225-3.6l-6.85,2.241a16.074,16.074,0,0,1-.505,4.825H27.449a16.077,16.077,0,0,1-.508-4.825l-6.848-2.241a15.959,15.959,0,0,1-3.227,3.6l-5.93-4.337a16.063,16.063,0,0,1,2.407-4.2l-4.23-5.867A15.806,15.806,0,0,1,4.4,44.079L2.131,37.063a15.774,15.774,0,0,1,4.4-1.979V27.83a15.758,15.758,0,0,1-4.4-1.974L4.4,18.838a15.882,15.882,0,0,1,4.716,1.005l4.23-5.867a16.063,16.063,0,0,1-2.407-4.2l5.93-4.337a16.011,16.011,0,0,1,3.227,3.6Z",
    transform: "translate(-2.131 -1.973)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 18.809,
    cy: 18.939,
    rx: 18.809,
    ry: 18.939,
    transform: "translate(10.174 10.545)",
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleSoftwares);
export default __webpack_public_path__ + "static/media/icon-module-softwares.3a98ade3.svg";
export { ForwardRef as ReactComponent };